"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollbarSizeListener = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ScrollbarSizeListener =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ScrollbarSizeListener, _React$Component);

  function ScrollbarSizeListener(props) {
    var _this;

    _classCallCheck(this, ScrollbarSizeListener);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollbarSizeListener).call(this, props));
    _this.scrollbarHeight = 0;
    _this.scrollbarWidth = 0;
    _this.handleResize = (0, _utils.debounce)(function () {
      var handleChange = _this.props.handleChange;
      var prevHeight = _this.scrollbarHeight;
      var prevWidth = _this.scrollbarWidth;

      _this.setMeasurements();

      if (prevHeight !== _this.scrollbarHeight || prevWidth !== _this.scrollbarWidth) {
        handleChange({
          scrollbarHeight: _this.scrollbarHeight,
          scrollbarWidth: _this.scrollbarWidth
        });
      }
    }, 166); // Corresponds to 10 frames at 60 Hz.

    return _this;
  }

  _createClass(ScrollbarSizeListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          handleLoad = _this$props.handleLoad,
          handleChange = _this$props.handleChange;
      this.setMeasurements();
      handleLoad({
        scrollbarHeight: this.scrollbarHeight,
        scrollbarWidth: this.scrollbarWidth
      });

      if (handleChange) {
        window.addEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "setMeasurements",
    value: function setMeasurements() {
      var nodeRef = this.nodeRef;

      if (!nodeRef) {
        return;
      }

      this.scrollbarHeight = nodeRef.offsetHeight - nodeRef.clientHeight;
      this.scrollbarWidth = nodeRef.offsetWidth - nodeRef.clientWidth;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "scrollbar-size-listener",
        ref: function ref(_ref) {
          _this2.nodeRef = _ref;
        }
      }));
    }
  }]);

  return ScrollbarSizeListener;
}(_react.default.Component);

exports.ScrollbarSizeListener = ScrollbarSizeListener;
ScrollbarSizeListener.propTypes = {
  handleChange: _propTypes.default.func.isRequired,
  handleLoad: _propTypes.default.func.isRequired
};